import { STORAGE_CHANNEL_KEY, STORAGE_PLATFORM_KEY, STORAGE_TOKEN_KEY } from '@local-utils/const';

export const CustomHeaders = {};

/**
 *
 * @param key {string}
 * @param value {string}
 */
export function setHeaders(key, value) {
  CustomHeaders[key] = value;
}

export function removeHeaders(key) {
  delete CustomHeaders[key];
}

export function getDefaultHeaders() {
  const token = localStorage.getItem(STORAGE_TOKEN_KEY) || '';
  const platform = localStorage.getItem(STORAGE_PLATFORM_KEY) || import.meta.env.VITE_APP_PLATFORM;
  const channel =
    localStorage.getItem(STORAGE_CHANNEL_KEY) || import.meta.env.VITE_APP_DEFAULT_CHANNEL;

  const headers = {
    Authorization: token,
    'Yqw-Token': token,
    platform,
    channel,
  };

  return Object.keys(headers).reduce((obj, key) => {
    const value = headers[key];
    if (value) {
      obj[key] = value;
    }
    return obj;
  }, {});
}
